export const multiFwUpdateTableId = 'firmwareUpdate';

export const multiFwDefaultSorting = { id: 'c_uuid', desc: false };
